import React, { useState } from 'react';
import AWS from "aws-sdk";
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import axios from 'axios';

const stateCodes = {
    "ANDHRA PRADESH": "AP",
    "ARUNACHAL PRADESH": "AR",
    "ASSAM": "AS",
    "BIHAR": "BR",
    "CHHATTISGARH": "CG",
    "GOA": "GA",
    "GUJARAT": "GJ",
    "HARYANA": "HR",
    "HIMACHAL PRADESH": "HP",
    "JHARKHAND": "JH",
    "KARNATAKA": "KA",
    "KERALA": "KL",
    "MADHYA PRADESH": "MP",
    "MAHARASHTRA": "MH",
    "MANIPUR": "MN",
    "MEGHALAYA": "ML",
    "MIZORAM": "MZ",
    "NAGALAND": "NL",
    "ODISHA": "OR",
    "PUNJAB": "PB",
    "RAJASTHAN": "RJ",
    "SIKKIM": "SK",
    "TAMIL NADU": "TN",
    "TELANGANA": "TG",
    "TRIPURA": "TR",
    "UTTAR PRADESH": "UP",
    "UTTARAKHAND": "UK",
    "WEST BENGAL": "WB",

    // Union Territories
    "ANDAMAN AND NICOBAR ISLANDS": "AN",
    "CHANDIGARH": "CH",
    "DADRA AND NAGAR HAVELI AND DAMAN AND DIU": "DN",
    "DELHI": "DL",
    "JAMMU AND KASHMIR": "JK",
    "LADAKH": "LA",
    "LAKSHADWEEP": "LD",
    "PUDUCHERRY": "PY"
};

export default function PlayerIDForm({ userfc, setShowForm }) {
    const initialFromData = {
        userID: userfc.userID,
        state: '',
        name: '',
        age: '',
        gender: '',
        weight: '',
        height: '',
        dob: '',
        mobile: '',
        email: '',
        address: '',
        district: '',
        pincode: '',
        photo: '',
        idProof: '',
        password: '',
    }

    // Simplified photo and idProof state
    const [photoFile, setPhotoFile] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [idProofFile, setIdProofFile] = useState(null);
    const [idProofPreview, setIdProofPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [formData, setFormData] = useState(initialFromData);

    const handleFileChange = (event, setFile, setPreview) => {
        const file = event.target.files[0];
        if (file) {
            setFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSingleFileUpload = async (event, name) => {
        event.preventDefault();
        let file, preview;
        if (name === "photo") {
            file = photoFile;
            preview = photoPreview;
        } else {
            file = idProofFile;
            preview = idProofPreview;
        }
        if (!file) {
            alert(`Please Select ${name}`);
            return;
        }
        setLoading(true);
        let link = "";
        try {
            link = await uploadToS3(file);
        } catch {
            setLoading(false);
            alert(`Error Uploading ${name}`);
            return;
        }
        setFormData({
            ...formData,
            [name]: link,
        });
        setLoading(false);
    };

    const uploadToS3 = async (file) => {
        const S3 = new AWS.S3({
            accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
            region: process.env.REACT_APP_AWS_REGION
        });
        const params = {
            Bucket: `minf-uploads/kotr/registration/general`,
            Key: file.name,
            Body: file,
        };
        try {
            const data = await S3.upload(params).promise();
            return data.Location;
        } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    };

    function generatePlayerID(name, stateCode, digits = 2) {
        const [first, last] = name.trim().split(' ');
        const initials = (first[0] + (last?.[0] || '')).toUpperCase();
        const randomNum = Math.floor(Math.pow(10, digits - 1) + Math.random() * (9 * Math.pow(10, digits - 1)));

        return `W24${stateCode}${initials}${randomNum}`;
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedFields = { [name]: value };
        if (name === 'dob') {
            // Calculate age based on the date of birth
            const dobDate = new Date(value);
            const today = new Date();
            let ageDiff = today.getFullYear() - dobDate.getFullYear();
            if (
                today.getMonth() < dobDate.getMonth() ||
                (today.getMonth() === dobDate.getMonth() && today.getDate() < dobDate.getDate())
            ) {
                ageDiff = ageDiff - 1;
            }
            updatedFields.age = ageDiff;
        }
        setFormData({
            ...formData,
            ...updatedFields,
        });
    };

    const handleSubmit = async (e) => {
        const playerId = generatePlayerID(formData.name, stateCodes[formData.state.toUpperCase()])
        formData.playerId = playerId
        setLoading(true);
        console.log(formData)
        e.preventDefault();
        if (formData.idProof && formData.photo) {
            try {
                await axios.post(
                    `${process.env.REACT_APP_MINF_LATEST_BAC_BASE}/api/player`,
                    formData
                );
                setMessage("Thanks for Registering");
                setFormData(initialFromData);
                setLoading(false);
            } catch (error) {
                setMessage("Error");
                setLoading(false);
            }
        } else {
            setLoading(false);
            alert("Please Click on upload button after selecting the images for uploading and then submit");
        }
    };

    return (
        <div className="min-h-screen w-full max-w-5xl mx-auto px-4">
            <div className="max-w-full mx-auto">
                {/* Header */}
                <div className="text-center mb-10">
                    <h1 className="text-4xl font-bold text-black mb-2 tracking-tight">Player Profile</h1>
                    <p className="text-slate-600 text-lg">Fill in your details to complete your player profile</p>
                </div>

                {/* Form Card */}
                <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
                    <form onSubmit={handleSubmit} className="space-y-10">
                        {/* Section: Personal Details */}
                        <div>
                            <h2 className="text-xl font-semibold text-black mb-4">Personal Details</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="name">
                                        Full Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Enter your full name"
                                        required
                                        aria-required="true"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="dob">
                                        Date of Birth <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="date"
                                        name="dob"
                                        id="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        required
                                        aria-required="true"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="gender">
                                        Gender <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors bg-white"
                                        name="gender"
                                        id="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        required
                                        aria-required="true"
                                    >
                                        <option value="">Select Gender</option>
                                        <option>Male</option>
                                        <option>Female</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="age">
                                        Age <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg bg-slate-100 text-slate-600"
                                        type="number"
                                        name="age"
                                        id="age"
                                        value={formData.age}
                                        onChange={handleChange}
                                        required
                                        disabled
                                        aria-required="true"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Section: Physical Details */}
                        <div>
                            <h2 className="text-xl font-semibold text-black mb-4">Physical Details</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="weight">
                                        Weight (kg) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="number"
                                        name="weight"
                                        id="weight"
                                        value={formData.weight}
                                        onChange={handleChange}
                                        placeholder="Enter weight in kg"
                                        required
                                        aria-required="true"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="height">
                                        Height (cm) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="number"
                                        name="height"
                                        id="height"
                                        value={formData.height}
                                        onChange={handleChange}
                                        placeholder="Enter height in cm"
                                        required
                                        aria-required="true"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Section: Contact Information */}
                        <div>
                            <h2 className="text-xl font-semibold text-black mb-4">Contact Information</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="mobile">
                                        Mobile Number <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="tel"
                                        name="mobile"
                                        id="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        pattern="[0-9]{10}"
                                        title="Please enter a valid 10-digit mobile number"
                                        placeholder="Enter 10-digit mobile number"
                                        required
                                        aria-required="true"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="email">
                                        Email Address <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Enter your email address"
                                        required
                                        aria-required="true"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="address">
                                        Address <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                        type="text"
                                        name="address"
                                        id="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        placeholder="Enter your complete address"
                                        required
                                        aria-required="true"
                                    />
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="district">
                                            District <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                            type="text"
                                            name="district"
                                            id="district"
                                            value={formData.district}
                                            onChange={handleChange}
                                            placeholder="Enter district"
                                            required
                                            aria-required="true"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="pincode">
                                            Pincode <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                            type="text"
                                            name="pincode"
                                            id="pincode"
                                            value={formData.pincode}
                                            onChange={handleChange}
                                            placeholder="Enter pincode"
                                            required
                                            aria-required="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section: Account Security */}
                        <div>
                            <h2 className="text-xl font-semibold text-black mb-4">Account Security</h2>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="password">
                                    Password <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors placeholder-slate-400"
                                    type="password"
                                    name="password"
                                    id="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Create a secure password"
                                    required
                                    aria-required="true"
                                />
                            </div>
                        </div>

                        {/* Section: State Selection */}
                        <div>
                            <h2 className="text-xl font-semibold text-black mb-4">State Information</h2>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="state">
                                    State <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:border-black focus:ring-2 focus:ring-black transition-colors bg-white"
                                    name="state"
                                    id="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                    aria-required="true"
                                >
                                    <option value="">Select a State/Union Territory</option>
                                    <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                                    <option value="Andhra Pradesh">Andhra Pradesh</option>
                                    <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                    <option value="Assam">Assam</option>
                                    <option value="Bihar">Bihar</option>
                                    <option value="Chandigarh">Chandigarh</option>
                                    <option value="Chhattisgarh">Chhattisgarh</option>
                                    <option value="Dadra and Nagar Haveli and Daman and Diu">Dadra and Nagar Haveli and Daman and Diu</option>
                                    <option value="Delhi">Delhi</option>
                                    <option value="Goa">Goa</option>
                                    <option value="Gujarat">Gujarat</option>
                                    <option value="Haryana">Haryana</option>
                                    <option value="Himachal Pradesh">Himachal Pradesh</option>
                                    <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                                    <option value="Jharkhand">Jharkhand</option>
                                    <option value="Karnataka">Karnataka</option>
                                    <option value="Kerala">Kerala</option>
                                    <option value="Ladakh">Ladakh</option>
                                    <option value="Lakshadweep">Lakshadweep</option>
                                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                                    <option value="Maharashtra">Maharashtra</option>
                                    <option value="Manipur">Manipur</option>
                                    <option value="Meghalaya">Meghalaya</option>
                                    <option value="Mizoram">Mizoram</option>
                                    <option value="Nagaland">Nagaland</option>
                                    <option value="Odisha">Odisha</option>
                                    <option value="Puducherry">Puducherry</option>
                                    <option value="Punjab">Punjab</option>
                                    <option value="Rajasthan">Rajasthan</option>
                                    <option value="Sikkim">Sikkim</option>
                                    <option value="Tamil Nadu">Tamil Nadu</option>
                                    <option value="Telangana">Telangana</option>
                                    <option value="Tripura">Tripura</option>
                                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                                    <option value="Uttarakhand">Uttarakhand</option>
                                    <option value="West Bengal">West Bengal</option>
                                </select>
                            </div>
                        </div>

                        {/* Section: Document Upload */}
                        <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                            <h2 className="text-xl font-semibold text-black mb-4">Document Upload</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Photo Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-2" htmlFor="photo">
                                        Profile Photo <span className="text-red-500">*</span>
                                    </label>
                                    <div className="space-y-2">
                                        <div className={`relative cursor-pointer ${photoPreview ? "w-32 h-32" : "w-full h-24"} border-2 border-dashed border-slate-300 rounded-lg hover:border-black transition-colors bg-white flex items-center justify-center`}>
                                            <label htmlFor="photo" className="flex flex-col justify-center items-center h-full w-full cursor-pointer">
                                                {photoPreview ? (
                                                    <>
                                                        <img src={photoPreview} alt="Selected Photo" className="w-full h-full object-cover rounded-lg" />
                                                        <button type="button" className="absolute top-2 right-2 bg-white rounded-full p-1 shadow hover:bg-red-100" onClick={() => { setPhotoFile(null); setPhotoPreview(null); setFormData({ ...formData, photo: '' }); }} aria-label="Remove photo">
                                                            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                                                        </button>
                                                    </>
                                                ) : (
                                                    <div className="text-center">
                                                        <UploadRoundedIcon className="text-slate-400 mx-auto mb-1" />
                                                        <span className="text-xs text-slate-500">Click to upload photo</span>
                                                    </div>
                                                )}
                                                <input
                                                    className="hidden"
                                                    type="file"
                                                    name="photo"
                                                    id="photo"
                                                    accept="image/*"
                                                    required
                                                    onChange={(e) => handleFileChange(e, setPhotoFile, setPhotoPreview)}
                                                    aria-required="true"
                                                />
                                            </label>
                                        </div>
                                        {photoFile && <div className="text-xs text-slate-500 mt-1">{photoFile.name}</div>}
                                        <button
                                            className="w-full bg-black hover:bg-gray-900 text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                                            onClick={(e) => handleSingleFileUpload(e, "photo")}
                                            disabled={loading}
                                            type="button"
                                        >
                                            <UploadRoundedIcon fontSize="small" /> Upload Photo
                                        </button>
                                    </div>
                                </div>

                                {/* ID Proof Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-2" htmlFor="idProof">
                                        ID Proof <span className="text-red-500">*</span>
                                    </label>
                                    <div className="space-y-2">
                                        <div className={`relative cursor-pointer ${idProofPreview ? "w-32 h-32" : "w-full h-24"} border-2 border-dashed border-slate-300 rounded-lg hover:border-black transition-colors bg-white flex items-center justify-center`}>
                                            <label htmlFor="idProof" className="flex flex-col justify-center items-center h-full w-full cursor-pointer">
                                                {idProofPreview ? (
                                                    <>
                                                        <img src={idProofPreview} alt="Selected ID Proof" className="w-full h-full object-cover rounded-lg" />
                                                        <button type="button" className="absolute top-2 right-2 bg-white rounded-full p-1 shadow hover:bg-red-100" onClick={() => { setIdProofFile(null); setIdProofPreview(null); setFormData({ ...formData, idProof: '' }); }} aria-label="Remove ID proof">
                                                            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                                                        </button>
                                                    </>
                                                ) : (
                                                    <div className="text-center">
                                                        <UploadRoundedIcon className="text-slate-400 mx-auto mb-1" />
                                                        <span className="text-xs text-slate-500">Click to upload ID proof</span>
                                                    </div>
                                                )}
                                                <input
                                                    className="hidden"
                                                    type="file"
                                                    name="idProof"
                                                    id="idProof"
                                                    accept="image/*"
                                                    required
                                                    onChange={(e) => handleFileChange(e, setIdProofFile, setIdProofPreview)}
                                                    aria-required="true"
                                                />
                                            </label>
                                        </div>
                                        {idProofFile && <div className="text-xs text-slate-500 mt-1">{idProofFile.name}</div>}
                                        <button
                                            className="w-full bg-black hover:bg-gray-900 text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                                            onClick={(e) => handleSingleFileUpload(e, "idProof")}
                                            disabled={loading}
                                            type="button"
                                        >
                                            <UploadRoundedIcon fontSize="small" /> Upload ID Proof
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Submit and Cancel Buttons */}
                        <div className="pt-6 flex flex-col md:flex-row gap-4">
                            <button
                                className="flex-1 bg-black hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded-lg transition-colors text-lg shadow-md focus:outline-none focus:ring-2 focus:ring-black"
                                type="submit"
                                disabled={loading}
                            >
                                Complete Registration
                            </button>
                            <button
                                type="button"
                                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-colors text-lg shadow-md focus:outline-none focus:ring-2 focus:ring-gray-300"
                                onClick={() => setShowForm(false)}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Loading Overlay */}
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
                    <div className="bg-white rounded-lg p-6 shadow-lg">
                        <div className="flex items-center space-x-3">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-black"></div>
                            <span className="text-slate-700">Processing...</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Success/Error Modal */}
            {message && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="absolute inset-0 bg-black bg-opacity-30"></div>
                    <div className="bg-white rounded-lg p-6 shadow-lg max-w-sm w-full mx-4 relative">
                        <div className="text-center">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${message === "Thanks for Registering" ? "bg-green-100" : "bg-red-100"}`}>
                                {message === "Thanks for Registering" ? (
                                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                ) : (
                                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                )}
                            </div>
                            <h3 className={`text-lg font-medium mb-2 ${message === "Thanks for Registering" ? "text-green-600" : "text-red-600"}`}>
                                {message === "Thanks for Registering" ? "Registration Successful!" : "Registration Failed"}
                            </h3>
                            <p className="text-slate-600 mb-4 text-sm">
                                {message === "Thanks for Registering"
                                    ? "Your registration has been completed successfully."
                                    : "There was an error processing your registration. Please try again."}
                            </p>
                            <button
                                onClick={() => {
                                    setMessage("");
                                    if (message === "Thanks for Registering") {
                                        window.location.reload();
                                    }
                                }}
                                className={`w-full py-2 px-4 rounded-lg font-medium transition-colors ${message === "Thanks for Registering"
                                    ? "bg-green-600 hover:bg-green-700 text-white"
                                    : "bg-red-600 hover:bg-red-700 text-white"
                                    }`}
                            >
                                {message === "Thanks for Registering" ? "Continue" : "Try Again"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
